import { ReactNode } from "react";
import {
  SkeletonText as ChakraSkeletonText,
  type SkeletonTextProps as ChakraSkeletonTextProps
} from "@chakra-ui/react";

export type SkeletonTextProps = ChakraSkeletonTextProps & {
  isLoaded?: boolean;
  spacing?: string | number;
  skeletonHeight?: string | number;
  children?: ReactNode;
};

export function SkeletonText({
  isLoaded,
  spacing,
  skeletonHeight,
  children,
  rootProps,
  ...props
}: SkeletonTextProps) {
  if (isLoaded) {
    return <>{children}</>;
  }

  return (
    <ChakraSkeletonText
      {...props}
      rootProps={{
        gap: spacing,
        ...rootProps
      }}
      css={
        skeletonHeight
          ? {
              "& > *": { height: skeletonHeight }
            }
          : undefined
      }
    >
      {children}
    </ChakraSkeletonText>
  );
}
